/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />
      <div className='measures'>
        <h2>Covid-19-Massnahmen ab 29. Oktober</h2>

        <div className='ui equal width center aligned padded grid'>
          <div className='three column row'>
            <div className='column'>
              <div className='img-spacer'>
                <div className='img-wrapper'>
                  <img
                    src={require('./images/schutzmasken.svg')}
                    className='ui fluid image'
                  />
                </div>
              </div>
              Maskenpflicht u.a. in Fussgängerzonen, in Büros und in/vor
              öffentlichen Einrichtungen
            </div>
            <div className='column'>
              <div className='img-wrapper'>
                <img
                  src={require('./images/bar.svg')}
                  className='ui fluid image'
                />
              </div>
              Sperrstunde von{' '}
              <nobr>
                <strong>23 bis 6 Uhr</strong>
              </nobr>{' '}
              für Restaurants und Bars
            </div>
            <div className='column'>
              <div className='img-wrapper'>
                <img
                  src={require('./images/club-locked.svg')}
                  className='ui fluid image'
                />
              </div>
              Schliessung von Clubs und Tanzlokalen
            </div>

            <div className='column'>
              <div className='img-spacer'>
                <div className='img-wrapper'>
                  <img
                    src={require('./images/treffen.svg')}
                    className='ui fluid image'
                  />
                </div>
              </div>
              Maximal{' '}
              <nobr>
                <strong>10 Personen</strong>
              </nobr>{' '}
              bei privaten Treffen
            </div>
            <div className='column'>
              <div className='img-wrapper'>
                <img
                  src={require('./images/veranstaltungen.svg')}
                  className='ui fluid image'
                />
              </div>
              Öffentliche Veranstaltungen mit maximal{' '}
              <nobr>
                <strong>50 Teilnehmern</strong>
              </nobr>
            </div>
            <div className='column'>
              <div className='img-wrapper'>
                <img
                  src={require('./images/kontaktsport.svg')}
                  className='ui fluid image'
                />
              </div>
              Verbot von Sportarten mit Körperkontakt
            </div>
          </div>
        </div>
      </div>

      <div className='foot'>
        <p className='source'>
          Quelle: Bundesrat,{' '}
          <a
            href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/novel-cov.html
'
            target='_blank'
          >
            Bundesamt für Gesundheit
          </a>
          <br />
          Grafik: lm
        </p>
      </div>
    </div>
  )
}
